/**
 * GrowthCommandCenterCampaignsAlertsSection — Campanhas table + Alertas & Recomendações
 * Sub-component of GrowthCommandCenter
 */
import React from "react";

export default function GrowthCommandCenterCampaignsAlertsSection({ acoes }) {
  if (!acoes || acoes.length === 0) {
    return (
      <div className="bg-slate-50 rounded-lg p-8 text-center border border-slate-200">
        <p className="text-muted-foreground font-medium">Detalhamento por campanha ainda não disponível</p>
        <p className="text-xs text-muted-foreground mt-2">Conecte suas campanhas Meta Ads para ver análise por campanha</p>
      </div>
    );
  }

  const escalaCampanhas = acoes.filter(a => a.acao === "ESCALAR") || [];
  const desligaCampanhas = acoes.filter(a => a.acao === "DESLIGAR") || [];
  const mantemCampanhas = acoes.filter(a => a.acao === "MANTER") || [];

  return (
    <>
      {/* Campanhas Table */}
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm">
        <div className="bg-slate-50 border-b border-slate-200 px-6 py-4">
          <h3 className="font-bold text-slate-900">Campanhas</h3>
          <p className="text-xs text-muted-foreground mt-1">Ações recomendadas por ROAS</p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50">
                <th className="px-6 py-3 text-left font-semibold text-slate-900">Campanha</th>
                <th className="px-6 py-3 text-left font-semibold text-slate-900">ROAS</th>
                <th className="px-6 py-3 text-left font-semibold text-slate-900">Decisão</th>
              </tr>
            </thead>
            <tbody>
              {acoes.map((acao, idx) => {
                let badgeColor = "bg-yellow-100 text-yellow-800";
                let emojiIcon = "🟡";
                if (acao.acao === "ESCALAR") {
                  badgeColor = "bg-green-100 text-green-800";
                  emojiIcon = "🟢";
                } else if (acao.acao === "DESLIGAR") {
                  badgeColor = "bg-red-100 text-red-800";
                  emojiIcon = "🔴";
                }
                return (
                  <tr key={idx} className="border-b border-slate-100 hover:bg-slate-50 transition">
                    <td className="px-6 py-4 font-medium text-slate-900">{acao.campanha}</td>
                    <td className="px-6 py-4 text-slate-600 font-semibold">{acao.roas?.toFixed(2)}x</td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold ${badgeColor}`}>
                        {emojiIcon} {acao.acao}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="bg-slate-50 border-t border-slate-200 px-6 py-3">
          <p className="text-xs text-muted-foreground">
            ℹ️ Detalhes por campanha (gasto/receita/CAC) em breve
          </p>
        </div>
      </div>

      {/* Alertas & Recomendações */}
      {(escalaCampanhas.length > 0 || desligaCampanhas.length > 0) && (
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm">
          <div className="bg-slate-50 border-b border-slate-200 px-6 py-4">
            <h3 className="font-bold text-slate-900">Alertas & Recomendações</h3>
            <p className="text-xs text-muted-foreground mt-1">O que fazer hoje</p>
          </div>
          <div className="p-6 space-y-4">
            {/* ESCALAR */}
            {escalaCampanhas.length > 0 && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <h4 className="font-semibold text-green-900 mb-2">🟢 ESCALAR IMEDIATAMENTE</h4>
                <div className="space-y-2">
                  {escalaCampanhas.map((camp, idx) => (
                    <div key={idx} className="text-sm text-green-800">
                      <span className="font-medium">{camp.campanha}</span>
                      <span className="text-green-600"> — ROAS {camp.roas?.toFixed(2)}x</span>
                      <p className="text-xs text-green-600 mt-1">💡 Aumentar orçamento em 30%</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* DESLIGAR */}
            {desligaCampanhas.length > 0 && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <h4 className="font-semibold text-red-900 mb-2">🔴 DESLIGAR HOJE</h4>
                <div className="space-y-2">
                  {desligaCampanhas.map((camp, idx) => (
                    <div key={idx} className="text-sm text-red-800">
                      <span className="font-medium">{camp.campanha}</span>
                      <span className="text-red-600"> — ROAS {camp.roas?.toFixed(2)}x (abaixo do breakeven)</span>
                      <p className="text-xs text-red-600 mt-1">💡 Redirecionar orçamento para campanhas verdes</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* MANTER */}
            {mantemCampanhas.length > 0 && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <h4 className="font-semibold text-yellow-900 mb-2">🟡 MONITORAR</h4>
                <div className="space-y-2">
                  {mantemCampanhas.map((camp, idx) => (
                    <div key={idx} className="text-sm text-yellow-800">
                      <span className="font-medium">{camp.campanha}</span>
                      <span className="text-yellow-600"> — ROAS {camp.roas?.toFixed(2)}x</span>
                      <p className="text-xs text-yellow-600 mt-1">💡 Manter e monitorar diariamente</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
